import type {
	CustomItem,
	DropHeroType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropHero = (item: Item | CustomItem): item is DropHeroType => {
	return !!(item && item.__typename === 'Drop_Hero');
};
